import {
  getClientNameOpts,
  GetClientNameOptsResponse,
} from "../../../services/accountService";
import { useQuery } from "@tanstack/react-query";

export default function useClientNameOptsQuery(accountHolderCode: string = "") {
  return useQuery<GetClientNameOptsResponse, string>(
    ["clientNameOpts", accountHolderCode],
    () => getClientNameOpts(accountHolderCode)
  );
}
